import Vue from "vue";
import {ValidationProvider,ValidationObserver, extend, localize} from "vee-validate";

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import * as rules from 'vee-validate/dist/rules';

for (let rule in rules) {
    extend(rule, rules[rule]);
}

import pl from 'vee-validate/dist/locale/pl.json';
// Kod języka w DealerID to 'ua' (LanguageSelect.vue), a paczka vee-validate
// nazywa ten słownik 'uk' — stąd rozjazd nazw. CU-869etcmnd.
import uk from 'vee-validate/dist/locale/uk.json';

localize('pl', pl);
localize('ua', uk);
